import React, { Component } from 'react';
import { Button, Input, DatePicker } from 'antd';
import $ from '../../../common/AjaxRequest';
import API_URL from '../../../common/url';
import moment from 'moment';

const monthFormat = 'YYYY-MM';
const { MonthPicker } = DatePicker;

class Filter extends Component {
    state = {
        maxMonth: '',
        searchParams: {},
    }

    componentDidMount() {
        this.queryDate();
    }

    queryDate = () => {
        const options = {
            url: API_URL.user.queryPmScoreGradeDate,
            data: {},
            dataType: 'json',
            doneResult: res => {
                const { date } = res;
                const { searchParams } = this.state;
                searchParams.inspectionTime = date;
                const maxMonth = date;
                this.setState({
                    maxMonth,
                    searchParams,
                }, () => {
                    this.search();
                });
            },
        };
        $.sendRequest(options);
    }

    search = () => {
        const { searchParams } = this.state;
        this.props.search({ searchParams });
    }

    export = () => {
        this.props.export();
    }

    enterSearch = e => {
        if (e.charCode === 13) {
            this.search();
        }
    }

    handleDateChange = (data, dateString) => {
        const { searchParams } = this.state;
        searchParams.inspectionTime = dateString;
        this.setState({ searchParams });
    }

    handleInputChange = (e, field) => {
        const { searchParams } = this.state;
        searchParams[field] = e.target.value;
        this.setState({ searchParams });
    }

    disabledDate = (current) => {
        const { maxMonth } = this.state;
        return current && current.valueOf() >= moment(maxMonth).add(1, 'M').valueOf();
    }

    render() {
        const { canSynchronize, synchronizeUser } = this.props;
        const {
            searchParams: {
                inspectionTime,
            }
        } = this.state;
        const newInspectionTime = inspectionTime ? moment(inspectionTime) : null;
        return (
            <div className="filter-bar">
                <div className="filter-bar-investigation">
                    <div className="form-item">
                        <label className="ui-label">考核时间</label>
                        <MonthPicker
                            style={{width:90}}
                            format={monthFormat}
                            value={newInspectionTime}
                            placeholder="请选择"
                            allowClear={false}
                            disabledDate={this.disabledDate}
                            onChange={this.handleDateChange}
                            className="w-90-select"
                        />
                    </div>
                    <div className="form-item">
                        <label htmlFor="" className="ui-label">工号</label>
                        <Input
                            placeholder="请输入"
                            onChange={e => this.handleInputChange(e, 'employeeCode')}
                            onKeyPress={this.enterSearch}
                        />
                    </div>
                    <div className="form-item">
                        <label htmlFor="" className="ui-label">姓名</label>
                        <Input
                            placeholder="请输入"
                            onChange={e => this.handleInputChange(e, 'userCompellation')}
                            onKeyPress={this.enterSearch}
                        />
                    </div>
                    <div className="form-item">
                        <Button type="primary" onClick={this.export}>导出</Button>
                        {
                            canSynchronize ?
                                <Button type="primary" onClick={synchronizeUser} style={{ background: '#62cf96', border: '1px solid #00a854' }}>同步人员</Button>
                            :
                                <Button disabled={true}>同步人员</Button>
                        }
                        <Button type="primary" onClick={this.search}>搜索</Button>
                    </div>
                </div>
            </div>
        );
    }
}

export default Filter;


// WEBPACK FOOTER //
// ./src/components/user/crcTeamContributeScore/Filter.js